/**
 * The base url for dspin.
 */
export const DS_PIN_BASE_URL = '/v1/dspin/projects/';
